import React, { Component } from "react";
import styles from "./styles.module.scss";
import styled from "styled-components";
import navRoutes from "Navigation/NavRoutes";
import { IoMdClose } from "react-icons/io";

const NavItem = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  font-family: Roboto;
  letter-spacing: 2px;
`;

const Navigation = ({ handleNavigate, user, logout }) => {
  return (
    <>
      <NavItem onClick={() => handleNavigate(navRoutes.postUpdate)}>
        Post an update
      </NavItem>
      <NavItem onClick={() => handleNavigate(navRoutes.createProject)}>
        Create a project
      </NavItem>
      <NavItem onClick={() => handleNavigate(navRoutes.updateFeed)}>
        Latest Updates
      </NavItem>
      <NavItem onClick={() => handleNavigate(navRoutes.explore)}>
        Explore
      </NavItem>
      <NavItem
        onClick={() => handleNavigate(`${navRoutes.profile}/${user.id}`)}
      >
        Profile
      </NavItem>
      <NavItem onClick={() => handleNavigate(navRoutes.myProjects)}>
        My Projects
      </NavItem>
      <NavItem onClick={() => handleNavigate(navRoutes.settings)}>
        Settings
      </NavItem>
      <NavItem onClick={() => logout()}>Logout</NavItem>
    </>
  );
};

class MobileNavigation extends Component {
  handleNavigate = route => {
    const { history, onHide } = this.props;
    history.push(route);
    onHide();
  };

  handleLogout = () => {
    this.props.logout();
    this.props.onHide();
  }

  state = {};
  render() {
    const { open, user, onHide } = this.props;
    return (
      <div className={open ? styles.showContainer : styles.hideContainer}>
        <div className={styles.background} />
        <div
          className={
            open ? styles.sidebarContainerOpen : styles.sidebarContainerClosed
          }
        >
          <div className={styles.closeIcon}>
            <IoMdClose fontSize={40} onClick={onHide} />
          </div>
          <Navigation handleNavigate={route => this.handleNavigate(route)} user={user} logout={this.handleLogout}/>
        </div>
      </div>
    );
  }
}

export default MobileNavigation;
